import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { TypeOfSelectors } from "app/pages/sales-intelligence/common-components/MultiSelector/types";
import { fetchExcelQuotaThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import type { TableActionProps } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/TableActionsPanel/types";
import WebsitesExportOptionsDropdownContainer from "app/pages/sales-intelligence/sub-modules/company-search/containers/WebsitesExportOptionsDropdown/WebsitesExportOptionsDropdownContainer";
import ExcelCompetitorsExportPanel from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/ActivatedExportPanel/ExcelCompetitorsExportPanel";
import DynamicsCompetitorsExportPanel from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/ActivatedExportPanel/DynamicsCompetitorsExportPanel";
import SalesforceCompetitorsExportPanel from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/ActivatedExportPanel/SalesforceCompetitorsExportPanel";
import HubSpotCompetitorsExportPanel from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/ActivatedExportPanel/HubSpotCompetitorsExportPanel";

const ExportCompetitorsButton = (props: TableActionProps) => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(fetchExcelQuotaThunk());
    });

    function handleSelect(variant: TypeOfSelectors) {
        switch (variant) {
            case TypeOfSelectors.EXCEL:
                return props.onActivate(() => ExcelCompetitorsExportPanel);
            case TypeOfSelectors.EXPORT_SALES_FORCE:
                return props.onActivate(() => SalesforceCompetitorsExportPanel);
            case TypeOfSelectors.EXPORT_HUBSPOT:
                return props.onActivate(() => HubSpotCompetitorsExportPanel);
            case TypeOfSelectors.EXPORT_DYNAMICS:
                return props.onActivate(() => DynamicsCompetitorsExportPanel);
            default:
                return undefined;
        }
    }

    return (
        <WebsitesExportOptionsDropdownContainer
            isDisabled={props.isDisabled}
            onOptionSelect={handleSelect}
        />
    );
};

export default ExportCompetitorsButton;
